import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import BackHeader from '../layout/BackHeader';

const CustomerSupport = () => {
  const linkRef = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    const anchorElement = linkRef.current;

    const handleMouseDown = (e) => {
      const url = e.target.getAttribute('href').split('mailto:')[1];

      setTimeout(() => {
        navigator.clipboard.writeText(url);
      }, 1000);
    };

    const timeout = anchorElement.addEventListener('mousedown', handleMouseDown);

    const handleMouseUp = () => clearTimeout(timeout);

    anchorElement.addEventListener('mouseup', handleMouseUp);

    return () => {
      anchorElement.removeEventListener('mousedown', handleMouseDown);
      anchorElement.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <>
      <BackHeader title={t('cs')} />
      <section className="customer-support-section handle-fixed-nav">
        <div className="cs-div">
          <p className="cs-header">{t('cs_1')}</p>
          <p className="cs-text">
            {t('cs_2')}{' '}
            <span>
              <a ref={linkRef} href="mailto:support@360mea.com" className="email-link">
                support@360mea.com
              </a>
            </span>
            .
          </p>
          <p className="cs-text">{t('cs_3')}</p>
        </div>
      </section>
    </>
  );
};

export default CustomerSupport;
